<template>
  <div>
    <table-controls-vue
      v-if="!loading && items.length"
      :has-sticky="true"
      :no-scroll-direction="true"
      classes="is-marginless-bottom">
      <table class="table is-narrow is-fullwidth is-striped-v is-last-fixed-small has-actionsontd">
        <thead class="has-cells-vcentered">
          <tr class="is-size-6">
            <th>
              <span>Titre</span>
            </th>
            <th>
              <span>Note</span>
            </th>
            <th>
              <span>Auteur</span>
            </th>
            <th v-if="isAdmin || isManager">
              <span>Pour</span>
            </th>
            <th>
              <span>Date</span>
            </th>
            <th class="has-text-centered"></th>
          </tr>
        </thead>
        <tbody class="has-cells-vcentered">
          <tr
            v-for="(reminder, i) in items"
            :key="reminder.pk"
            class="is-size-6"
            :id="'e' + reminder.pk">
            <td>
              {{ reminder.title }}
            </td>
            <td>
              <span v-html="reminder.note"></span>
            </td>
            <td>
              {{ reminder.author.last_name }} {{ reminder.author.first_name }}
            </td>
            <td v-if="isAdmin || isManager">
              <span
                v-if="reminder.user.pk === currentUser.pk">
                Vous
              </span>
              <span
                v-else>
                {{ reminder.user.last_name }} {{ reminder.user.first_name }} <span v-if="reminder.user.account.pk !== currentUser.account.pk">({{ reminder.user.account.name }})</span>
              </span>
            </td>
            <td
              @click="goToDay(reminder.date)"
              class="is-cell-hoverable has-cursor-pointer">
              {{ reminder.date | prettyFullDatetime }}
            </td>
            <td>
              <display-button-list
                :buttons="buttonList"
                :data="reminder"
                :open-up="{'position': i, 'total': items.length}">
              </display-button-list>
            </td>
          </tr>
          <!--<tr class="empty empty--row" v-for="n in items.length < 4 ? 4 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>-->
        </tbody>
      </table>
    </table-controls-vue>
    <div v-show="!loading && !items.length">
      <div class="is-padding">
        <h2 class="title is-3 has-text-weight-bold">
          Aucun rappel à afficher
        </h2>
        <a
          class="has-text-primary"
          @click="resetFilters"
          v-if="hasFilter"><span class="icon"><i class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
      </div>
    </div>
    <pagination
      :loading="loading"
      :current-page="currentPage"
      :total-page="totalPage"
      @changePage="loadItems($event)"></pagination>
  </div>
</template>

<script>
import { Quickview } from '@/mixins'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'ReminderList',
  mixins: [Quickview],
  props: {
    items: Array,
    hasFilter: Boolean,
    currentPage: Number,
    totalPage: Number
  },
  data () {
    return {
      deleteTitle: 'Suppression rappel',
      deleteText: 'Le rappel ne sera plus consultable.',
      loading: false,
      buttonList: [
        {
          action: (id, reminder) => {
            this.goToDay(reminder.date)
          },
          icon: 'fa-eye',
          text: 'Voir'
        },
        {
          action: (id, reminder) => {
            this.updateReminder(reminder)
          },
          icon: 'fa-edit',
          text: 'Modifier'
        },
        {
          action: (id, reminder) => {
            this.deleteItem(reminder)
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer'
        }
      ]
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isManager'])
  },
  methods: {
    confirmDelete () {
      return this.$swal({
        title: 'Suppression rappel',
        text: 'Le rappel ne sera plus consultable.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    async deleteItem (reminder) {
      let r = await this.confirmDelete()
      if (r.value) {
        let eventPk = reminder.pk
        let key = moment(reminder.date).format('DD/MM/YYYY')
        try {
          await this.$api.delete(this.$resources.REMINDER, eventPk)
          this.$emit('loadItems')
          this.$store.commit('removeCalendarEvent', { eventPk, key, type: 'reminders' })
          this.$toasted.global.success('Le rappel à été supprimé.')
        } catch (err) {
          console.log(err)
          this.handleError(err)
        }
      }
    },
    updateReminder (source) {
      let params = {
        source,
        type: 'reminder'
      }
      this.openCalendarNewAction(params)
    },
    goToDay (date) {
      let day = moment(date).format('DD')
      let month = moment(date).format('MM')
      let year = moment(date).format('YYYY')
      this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'reminders' } })
    },
    resetFilters () {
      this.$emit('resetFilters', event)
    },
    loadItems (event) {
      this.$emit('loadItems', event)
    }
  }
}
</script>
